








































































import { defineComponent, reactive, toRefs } from "@vue/composition-api";
import { HttpPOST, ValidateEmail } from "@/code/Utils";
import Alerts, { AlertType } from "../code/alerts";

export default defineComponent({
  name: "Recuperacion",
  setup() {
    const data = reactive({
      email: "",
      password: "",
      newpassword: "",
      renewpassword: "",
    });

    const ChangePassword = async () => {
      // Validación vacio
      if (data.email.trim() !== "" && data.password.trim() !== "" && data.newpassword.trim() !== "" && data.renewpassword.trim() !== "") {
        // Validación password tamaño
        if (data.newpassword.length > 15 || data.newpassword.length < 8) {
          Alerts.Throw(
            "La contraseña debe poseer entre 8 y 10 caracteres.",
            AlertType.Danger,
            false,
            6000
          );
          return;
        }

        // Validación password caracteres validos
        var regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
        if (!data.newpassword.match(regex)) {
          Alerts.Throw(
            `La contraseña solo puede contar:
            1 Carácter Mayúscula minimo (A, Z)
            1 Carácter Minúscula minimo (a,z)
            1 Carácter Especial minimo (#$%&$)
            Cantidad de caracteres 8 o mayor con limitación a 10.
            `,
            AlertType.Danger,
            false,
            6000
          );
          return;
        }

        // Validación ambos pass iguales
        if (data.newpassword !== data.renewpassword) {
          Alerts.Throw(
            "Las contraseñas nuevas no coinciden.",
            AlertType.Danger,
            false,
            6000
          );
          return;
        }

        const xml = `<?xml version="1.0" encoding="utf-8"?>
                      <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                        <soap12:Body>
                          <ModificarPassDDJJ xmlns="http://tempuri.org/">
                            <userName>${data.email}</userName>
                            <pass_old>${data.password}</pass_old>
                            <pass_new>${data.newpassword}</pass_new>
                          </ModificarPassDDJJ>
                        </soap12:Body>
                      </soap12:Envelope>`

        const result = (await HttpPOST(xml, null)) as XMLHttpRequest;

        console.log(result.statusText + " - "  + result.status);
        // Validación websvc
        if (result.statusText === "OK") {
          data.email = "";
          data.password = "";
          data.newpassword = "";
          data.renewpassword = "";
          Alerts.Throw(
            `Su nueva contraseña quedó guardada, por favor vuelva a la pantalla de Login e ingrese sus nuevos datos para acceder al sistema.
                                <br/><br/>
                                <a href="./"><b>Volver</b></a>`,
            AlertType.Success,
            true
          );
        }
      } else {
        Alerts.Throw(
          "Por favor, verifique los campos para recuperar su contraseña.",
          AlertType.Danger,
          false,
          6000
        );
      }
    };

    const ShowHidePassword = (ATagid: string, Inputid: string) => {
      const a = document.getElementById(ATagid);
      const icon = document.querySelector(`#${ATagid} i`);
      const input = document.getElementById(Inputid);
      const atr = input.getAttribute("type");
      const contains = icon.classList.contains("fa-eye-slash");
      const title = a.getAttribute("title");
      a.setAttribute(
        "title",
        title == "Mostrar Contraseña"
          ? "Ocultar Contraseña"
          : "Mostrar Contraseña"
      );
      icon.classList.remove(contains ? "fa-eye-slash" : "fa-eye");
      icon.classList.add(contains ? "fa-eye" : "fa-eye-slash");
      input.setAttribute("type", atr == "password" ? "text" : "password");
    };

    return {
      ...toRefs(data),
      ChangePassword,
      ShowHidePassword
    };
  },
});
